import * as moment from '@node_modules/moment';
import { ProgramScheduleComponent } from '@pages/layout/program/program-page/program-schedule/program-schedule.component'
import {forEach} from "@node_modules/@angular/router/src/utils/collection";

export class ScheduleFacade {

  static getTrafficLight(timeStringStart: string, timeStringEnd: string, format: string) : string {
      const momentGivenStart = moment(timeStringStart, format);
      const momentGivenEnd = moment(timeStringEnd, format);
      const currentMoment = moment();
    // console.log(momentGivenStart.unix());
    // console.log(momentGivenEnd.unix());
    // console.log(currentMoment.unix());
    // console.log(momentGivenStart.format(format));
    // console.log(momentGivenEnd.format(format));
    // console.log(currentMoment);
    // console.log(currentMoment.unix() <= momentGivenEnd.unix());
    // console.log(currentMoment.unix() >= momentGivenStart.unix());
    if(currentMoment.isBefore(momentGivenStart)) {
      return 'upcoming'
    }
    if (timeStringEnd) {
      if (currentMoment.isBetween(momentGivenStart, momentGivenEnd)) {
        return 'current';
      }
      if(currentMoment.isAfter(momentGivenEnd)) {
        return 'past'
      }
    } else if (currentMoment.isAfter(momentGivenStart)){
      return 'current';
    }
  }

  static getLessonsByMonth(programId: number, month: string, dateFormat: string = 'll'){
    const schedule = ProgramScheduleComponent.schedulesWithLesson;
    const lessons = [];
    let lesson: {program_id: number};
    for(let date in schedule) {
      const g = moment(date, dateFormat);
      let scheduleMonth = g.format('MMM');

      if(month === scheduleMonth) {
      Object.keys(schedule[date]).map(key => {

        lesson = schedule[date][key];
        if(lesson.program_id === programId) {
          lessons.push(lesson);
        }

        });
      }
    }
    return lessons;
  }
}
